var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "M32 7.339 6.095 33.244V64h51.772V33.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4E0",
    d: "M30.477 64H15.238V47.838c0-4.597 3.486-8.22 7.619-8.22 4.266 0 7.62 3.763 7.62 8.22z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.095,
    height: 6.095,
    x: 36.838,
    y: 41.47,
    fill: "#00A4E0",
    rx: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.095,
    height: 6.095,
    x: 45.982,
    y: 41.47,
    fill: "#00A4E0",
    rx: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.095,
    height: 6.095,
    x: 36.572,
    y: 50.878,
    fill: "#00A4E0",
    rx: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.095,
    height: 6.095,
    x: 45.715,
    y: 50.878,
    fill: "#00A4E0",
    rx: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4E0",
    d: "M31.972 30.423a4.546 4.546 0 1 0 .005-9.092 4.546 4.546 0 0 0-.005 9.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9700",
    d: "M62.818 29.536 34.202.922l-.022.02a3.04 3.04 0 0 0-4.586.214l-.015-.015L1.182 29.536a3.044 3.044 0 1 0 3.96 4.617l.02.023L32 7.339l26.837 26.837.022-.023a3.044 3.044 0 1 0 3.96-4.617z"
  }))));
};
export default SvgHouse;